import React, { useState, useEffect } from "react";
import moment from "moment";
import about from "../../assets/image/nha-logo.png";
import { useLocation } from "react-router-dom";

const ConfirmPatientDetail = ({
  setIsconfirm,
  handleBack,
  setCurrentStep,
  userData
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const [confirmdetail, setConfirmDetail] = useState(null);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const paramsObj = Object.fromEntries(searchParams.entries());

  useEffect(() => {
    if (userData) {
      window.history.pushState(null, null, null);
      window.addEventListener("popstate", function (event) {
        window.history.pushState(null, null, null);
      });

      setConfirmDetail(userData);
    } else {
      try {
        const storedData = localStorage.getItem("selectedIndex");
        console.log(storedData, "store");
        if (storedData) {
          const parsedData = JSON.parse(storedData);
          setConfirmDetail(parsedData);
        }

      } catch (error) {
        console.error("Error parsing confirmdetail from localStorage:", error);
      }
    }
  }, [userData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isChecked) {
      // setIsconfirm(true);
      setCurrentStep("SendAdharOTP");
      localStorage.setItem("selectedIndex", JSON.stringify({_id:paramsObj.patientID, phone_number: paramsObj.mobileNumber}));

    }
  };

  return (
    <>
      <section className="container">
        <div className="abha-create-steps">
          <div className="row">
            <div className="col-md-6">
              <div className="create-abha">
                <h2>Create ABHA Number in 3 Steps</h2>
                <p>
                  Create ABHA and store all your medical records in one place.
                  Take part in the{" "}
                  <span className="highlight">
                    Ayushman Bharat Digital Mission (ABDM)
                  </span>{" "}
                  and get started on your digital health journey.
                </p>

                {/* Steps */}
                <div className="vertical-steps">
                  <div className="step-item">
                    <div className="step-marker">1</div>
                    <div className="step-content">
                      <h4>Verify Aadhaar Details</h4>
                      <p>
                        Enter your Aadhaar number and verify with OTP received
                        on Aadhaar linked mobile number.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">2</div>
                    <div className="step-content">
                      <h4>Link Mobile Number</h4>
                      <p>
                        Enter your mobile number and verify with OTP to link
                        with ABHA .
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">3</div>
                    <div className="step-content">
                      <h4>Create ABHA</h4>
                      <p>Create your ABHA Number with a unique ABHA .</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Form Card */}
            <div className="col-md-6">
              <div className="form-card content">
                <h3>Confirm Details</h3>
                <form onSubmit={handleSubmit} className="pt-5">
                  <div className="col-ms-10 col-lg-10 col-xl-10 col-sm-10 col-xs-10">
                    <div className="row">
                      <div className="">
                        <div className="col-ms-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12">
                          {confirmdetail ? (
                            <>
                              {/* Patient Card for patientId and mobile from query params */}
                              {confirmdetail?.patientId && confirmdetail?.mobile ? (
                                <div
                                  style={{ 
                                    padding: "20px", 
                                    border: "1px solid #ddd", 
                                    borderRadius: "8px",
                                    backgroundColor: "#f9f9f9",
                                    boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.24)",
                                    marginBottom: "20px"
                                  }}
                                >
                                  <h5 style={{ marginTop: 0, color: "#333", marginBottom: "15px" }}>Patient Information</h5>
                                  <div style={{ marginBottom: "12px" }}>
                                    <strong style={{ color: "#007bff" }}>Patient ID:</strong>
                                    <p style={{ margin: "5px 0 0 0", color: "#555", fontSize: "16px" }}>
                                      {confirmdetail.patientId}
                                    </p>
                                  </div>
                                  <div style={{ marginBottom: "12px" }}>
                                    <strong style={{ color: "#007bff" }}>Mobile:</strong>
                                    <p style={{ margin: "5px 0 0 0", color: "#555", fontSize: "16px" }}>
                                      {confirmdetail.mobile}
                                    </p>
                                  </div>
                                  {/* <p style={{ color: "#666", fontSize: "14px", marginBottom: 0, marginTop: "15px", fontStyle: "italic" }}>
                                    ✓ You can now proceed with your application.
                                  </p> */}
                                </div>
                              ) : (
                                /* Original patient card for other userData */
                                <div
                                  className="d-flex align-items-center bg-white p-3 mb-2 rounded"
                                  style={{
                                    boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.24)"
                                  }}
                                >
                                  <div
                                    className="avatar-initial me-3 d-flex align-items-center justify-content-center text-white fw-bold"
                                    style={{
                                      width: "50px",
                                      height: "50px",
                                      borderRadius: "50%",
                                      backgroundColor: "#007bff",
                                      fontSize: "20px",
                                      textTransform: "uppercase"
                                    }}
                                  >
                                    {confirmdetail?.name?.charAt(0)||confirmdetail?.first_name?.charAt(0)||confirmdetail?.last_name?.charAt(0)}
                                  </div>
                                  <div>
                                    <h5 className="mb-1 patient-name">
                                      {confirmdetail.name||[confirmdetail.first_name,confirmdetail.last_name].join(" ")}
                                    </h5>
                                    <div className="d-flex flex-wrap gap-2 patient-self">
                                      <span>Self |</span>
                                      <span>
                                        {confirmdetail?.gender === 0
                                          ? "Male"
                                          : "Female"}{" "}
                                        |
                                      </span>
                                      <span>
                                        {moment(confirmdetail?.dob).format(
                                          "DD-MM-YYYY"
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          ) : (
                            <p>No patient selected.</p>
                          )}

                          <div className="d-flex">
                            <input
                              type="checkbox"
                              className="form-check-input checkbox-color"
                              id="flexCheckDefault"
                              autoComplete="off"
                              checked={isChecked}
                              onChange={() => setIsChecked(!isChecked)}
                            />
                            <label
                              className="form-check-label ps-2 mb-2"
                              htmlFor="flexCheckDefault"
                            >
                              I agree to{" "}
                              <a
                                href="https://www.lalpathlabs.com/term-of-use"
                                class="resend-otp"
                                title="Terms of Use"
                                target="_blank"
                              >
                                Terms & Conditions
                              </a>{" "}
                              and{" "}
                              <a
                                href="https://www.lalpathlabs.com/privacy-policy"
                                class="resend-otp"
                                title="Privacy Policy"
                                target="_blank"
                              >
                                Privacy Policy
                              </a>{" "}
                              Lal Path Labs to Create/Link my ABHA .
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-ms-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12">
                    <div className="row">
                      <div className="col-ms-6 col-lg-6 col-xl-6 col-sm-6 col-xs-6">
                        <button className="back-btn" onClick={handleBack}>
                          Back
                        </button>
                      </div>
                      <div className="col-ms-6 col-lg-6 col-xl-6 col-sm-6 col-xs-6">
                        <button
                          type="submit"
                          className={`confirm-btn ${
                            !isChecked ? "bg-disable" : ""
                          }`}
                          disabled={!isChecked}
                        >
                          Continue
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="nha-logo-container">
                  <span className="text-black fs-6">CERTIFIED BY NHA</span>
                  <img src={about} alt="NHA Logo" className="nha-logo" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ConfirmPatientDetail;
